import * as React from "react";

export default () => {
  return <div>Ange vilka bekvämligheter som finns i objekten</div>;
};
